module.exports = __webpack_public_path__ + "img/LagerstandortGretzenbach.b9e3c9f.jpg";